export const getFlexRuletypeName = (name, ruleTypes) => {
  return `${name}-${ruleTypes[name][ruleTypes[name].length - 1]}`;
};
